import { AbstractControl } from '@angular/forms';
import { ValidationRegex } from '@app/origami-api/constants';

export function emailValidator(control: AbstractControl): { [key: string]: any } {
  if (!control.value) {
    return null; // don't validate empty values, use 'Required' validator if need
  }

  const value = control.value;
  const result = ValidationRegex.email.test(value);

  return result ? null : { emailValidator: { value } };
}
